(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcprinter
   * @description
   *
   */
  angular
    .module('vcdms.vcprinter', [
    ]);
}());
